import React, { Component } from "react";
import "../InitialForm/InitialFormStyleSheet.css";
import {
  isValidPhoneNumber,
  validateEmail,
  validateName,
} from "../HWLibrary/HWUtils";
import { s360ConfigService } from "../Services/S360Config";

class ChannelBox extends Component {
  constructor(props) {
    super(props);
    this.messageRef = React.createRef();
    // this.handleMouseHover = this.handleMouseHover.bind(this);
  }

  // handleMouseLeave(e) {
  //     e.target.style.background = 'none';

  //   }

  // handleMouseHover(e) {
  //     e.target.style.background = this.props.item.background;
  //   }

  render() {
    return (
      <div
      
        href={
          "#"
        } /*onMouseLeave={this.handleMouseLeave} onMouseEnter={this.handleMouseHover}*/
        className="styles_channel__396ZG styles_whatsapp__80fGh"
        target="_blank"
        rel="noopener noreferrer"
        style={{ width: "98%", border: "1px solid #d4cdcd", margin: "1%",borderRadius:'5px' }}
      >
        <div className="styles_channelIcon__1i0qs styles_whatsapp__80fGh">
          <img
            className="channelBoxBgColor"
            src={this.props.item.icon}
            width="24"
            height="24"
            alt="channel icon"
          ></img>
        </div>
        <p className="styles_channelName__Q8vJ4">{this.props.item.label}</p>
      </div>
    );
  }

  formInputBoxContainerStyle = () => {
    return {
      color: s360ConfigService.config.designDetails.headerColor,
    };
  };

  formInputBoxStyle = () => {
    return {
      borderColor: s360ConfigService.config.designDetails.headerColor,
      color: s360ConfigService.config.designDetails.headerColor,
      backgroundColor:
        s360ConfigService.config.designDetails.pageBackgroundColor,
    };
  };

  onClickInput = (e) => {
    if (e.target.value === this.props.item.label) {
      e.target.style.color = "rgb(0,0,0)";
      this.messageRef.current.value = "";
    }
  };

  onInputOut = (e) => {
    if (!e.target.value || !e.target.value.trim) {
      e.target.style.color = "inherit";
      this.messageRef.current.value = this.props.item.label;
    }
  };

  value = () => {
    if (
      !this.messageRef.current.value ||
      !this.messageRef.current.value.trim() ||
      this.messageRef.current.value.trim() === this.props.item.label
    ) {
      return {};
    }
    let aValue = {};
    aValue[this.props.item.label] = this.messageRef.current.value;
    return aValue;
  };

  validate = () => {
    let formItemDetails = this.props.item || {};
    let isRequired = formItemDetails.required || formItemDetails.primaryField;
    let isValidationEnabled = formItemDetails.validate !== "None";
    if (
      !this.messageRef.current.value ||
      !this.messageRef.current.value.trim() ||
      this.messageRef.current.value.trim() === this.props.item.label
    ) {
      return isRequired || isValidationEnabled ? false : true;
    }
    if (isValidationEnabled) {
      if (formItemDetails.validate.toLowerCase() === "phone") {
        return isValidPhoneNumber(this.messageRef.current.value);
      } else if (formItemDetails.validate.toLowerCase() === "email") {
        return validateEmail(this.messageRef.current.value);
      } else if (formItemDetails.validate.toLowerCase() === "name") {
        return validateName(this.messageRef.current.value);
      }
    }
    return true;
  };

  validationErrorMessage = () => {
    return "Please enter a valid " + this.props.item.label.toLowerCase() + ".";
  };
}

export default ChannelBox;
